import _ from 'lodash';
import genererAdresse from '@/services/general/genererAdresse';

export default function verifierAdresse(adresse) {
  const adresseInitiale = genererAdresse();
  Object.keys(adresse).forEach(key => {
    if (!adresse[key]) adresse[key] = null;
  });
  const result = _.isEqual(
    _.omit(adresseInitiale, ['departement', 'longitude', 'latitude']),
    _.omit(adresse, ['departement', 'longitude', 'latitude']),
  );

  return !result && (!adresse.intitule1 || !adresse.ville);
}



// WEBPACK FOOTER //
// ./src/services/client/verifierAdresse.js